import { render, staticRenderFns } from "./TwoFactorSetupWrapper.vue?vue&type=template&id=d38d2ac8&scoped=true"
import script from "./TwoFactorSetupWrapper.vue?vue&type=script&lang=js"
export * from "./TwoFactorSetupWrapper.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorSetupWrapper.vue?vue&type=style&index=0&id=d38d2ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38d2ac8",
  null
  
)

export default component.exports